module.exports = __webpack_public_path__ + "img/1.1.47bd6b3a.jpg";